import React from 'react';
import Layout from '../components/Layout/Layout';

// Import cultural images
import artImg from '../images/cultural-art.jpeg';
import festivalImg from '../images/cultural festival.jpeg';
import festival1Img from '../images/cultural festival1.jpeg';
import foodImg from '../images/cultural-food.jpeg';
import musicImg from '../images/cultural-music.jpeg';
import gatheringImg from '../images/gathering-image.jpg';
import annualImg from '../images/annual-day.jpeg';
import republicImg from '../images/republic-day.jpeg';

const CulturePage = () => {
  const culturalItems = [
    { title: 'Traditional Art', img: artImg, desc: "An engaging display of local talent and heritage through traditional art forms." },
    { title: 'Local Festival', img: festivalImg, desc: "vibrant celebrations of our region's rich cultural and religious festivals." },
    { title: 'Historic Artifact', img: festival1Img, desc: "Witness the legacy of bygone eras through our collection of historic artifacts." },
    { title: 'Regional Cuisine', img: foodImg, desc: "A delicious representation of the area's culinary traditions and local flavors." },
    { title: 'Cultural Performance', img: musicImg, desc: "Rhythmic melodies and traditional dance performances showcasing local culture." },
    { title: 'Annual Gathering', img: gatheringImg, desc: "A grand celebration of student achievements and cultural unity." },
    { title: 'College Foundation Day', img: annualImg, desc: "Celebrating the journey and growth of our esteemed institution." },
    { title: 'Republic Day', img: republicImg, desc: "Honoring the spirit of the nation with patriotic fervor and cultural pride." },
    { title: 'Traditional Art', img: musicImg, desc: "Preserving and promoting the artistic expressions of our heritage." },
    { title: 'Local Festival', img: festivalImg, desc: "Community gatherings that strengthen our cultural bonds and traditions." }
  ];

  return (
    <Layout>
      <div id="culture-page" className="page-container" style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 20px' }}>
        <h1 style={{ color: '#004488', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
          Cultural Gallery
        </h1>
        <div style={{ width: '80px', height: '4px', backgroundColor: '#add8e6', margin: '0 auto 40px auto' }}></div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '25px'
        }}>
          {culturalItems.map((item, index) => (
            <div key={index} style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              border: '1px solid #eee',
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center'
            }}>
              <div style={{ height: '180px', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
                <img src={item.img} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ padding: '20px' }}>
                <h3 style={{ color: '#004488', fontSize: '1.4rem', fontWeight: '600', marginBottom: '10px' }}>
                  {item.title}
                </h3>
                <p style={{ color: '#666', fontSize: '0.95rem', marginBottom: '20px', minHeight: '60px' }}>
                  {item.desc}
                </p>
                <button style={{
                  backgroundColor: '#007bff',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}>
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default CulturePage;
